import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "col-12 pb-3" };
const _hoisted_3 = {
    key: 0,
    class: "rounded-pill bg-brand_green_neon_light strong d-inline-block font8-responsive mr-2",
    style: { "height": "1.5rem", "line-height": "1.5rem !important", "padding": "0 0.6rem" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("span", {
                class: "rounded-pill bg-brand_green_neon_light strong d-inline-block font8-responsive mr-2",
                style: { "height": "1.5rem", "line-height": "1.5rem !important", "padding": "0 0.6rem" }
            }, " 30 Tage Geld zurück ", -1)),
            (((_a = _ctx.currentProduct) === null || _a === void 0 ? void 0 : _a.currentPrice) > 100)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Ratenzahlung verfügbar "))
                : _createCommentVNode("", true)
        ])
    ]));
}
